module.exports = "/assets/packs/images/dbaebed86221a58b6ececa72143dbe4a.svg";